<template>
    <div class="makemodelstepone">
        <div class="topheader">
            <div class="topheaderleft">
                欢迎您---{{username}}
            </div>
            <div class="topheaderright">
               <div class="back" @click="Back">
                   <i class="el-icon-arrow-left"></i>
                   <span>返回</span>
               </div>
               <div class="outlogin" @click="OutLogin">
                    <i class="el-icon-switch-button"></i>
                    <span>退出</span>
               </div>
            </div>

        </div>

        <div class="content">
            <div class="steps">
                <ul>
                    <li class="active">
                        <div class="steptop">
                            <span class="line"></span>
                            <span class="stepsicon">1</span>
                            <span class="line"></span>
                        </div>
                        <div class="stepbottom">
                            添加模型基本信息
                        </div>
                        
                    </li>
                    <li class="active">
                        <div class="steptop">
                            <span class="line"></span>
                            <span class="stepsicon">2</span>
                            <span class="line"></span>
                        </div>
                        <div class="stepbottom">
                            添加作物周期农事
                        </div>
                        
                    </li>
                    <li class="active">
                        <div class="steptop">
                            <span class="line"></span>
                            <span class="stepsicon">3</span>
                            <span class="line"></span>
                        </div>
                        <div class="stepbottom">
                            预览模型
                        </div>                        
                    </li>
                </ul>
            </div>
        </div>

        <div class="kh-list">
            <div class="kh-list-title">
                <span class="kh-list-title-tips">{{mxtitle}}</span>
            </div>          
            <div class="mxdet-content">
                <ul class="mxdet-lists">
                    <li v-for="item in MxdetContent">
                        <div class="list-title">
                            {{item.title}}
                        </div>
                        <div class="list-content">
                            {{item.content}}
                        </div>
                    </li>
                </ul>
            </div>
            <div class="zpyd-content">
                <div class="zpyd-title">
                    栽培技术要点
                </div>
                <div class="zpyd-lists">
                    <ul class="zpydlists">
                        <li v-for="item in zpydlists">
                            <div class="zpydlists-title">
                                <div class="title-icons"></div>
                                <img :src="requetImgUrl+item.zq_image" alt="" class="icons">
                                <div class="zpyd-times">{{item.zqmc}}</div>
                                <div class="zq-time">周期时长：{{item.zq_days}}天</div>
                            </div>
                            <el-table :data="item.nongshilist" border style="width: 100%">
                                <el-table-column
                                prop="workName"
                                label="农事事项"
                                align="center">
                                </el-table-column>
                                <el-table-column
                                prop="workDesc"
                                label="农事指导"
                                align="center">
                                </el-table-column>
                                <el-table-column
                                prop="nschufa"
                                label="触发条件"
                                align="center">   
                                </el-table-column>
                            </el-table>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="nextbtns">
            <el-button type="primary" @click="LinkTo" class="nextbtn">确定</el-button>
        </div>
    </div>
  </template>
  
  <script>
    import storage from '../../Storage/storage.js';
    export default {
      name: "Makemodelstepthree",
      data() {
        return {
          username:'',
          pagenum:1,
          limit:10,
          zwtotal:0,
          mxtitle:'',
        MxdetContent: [
            {
                title:'物种：',
                content:'',
            },
            {
                title:'品种名称：',
                content:'',
            },
            {
                title:'模型名称：',
                content:'',
            },
            {
                title:'种植区域：',
                content:'',
            },
            {
                title:'品种来源：',
                content:'',
            },
            {
                title:'产量结果：',
                content:'',
            },
            {
                title:'抗性鉴定：',
                content:'',
            }
        ],
    zpydlists:[],
    cftjspan:'',
    requetImgUrl:'',
    upimgurl:'',
    myHeaders: {token: ""},
    }
},
    methods: {
        Back(){
            this.$router.go(-1);
        },
        OutLogin(){
           storage.remove('token');
           storage.remove('userid');
           storage.remove('username');
           this.$router.push({
                    path: '/',
                    query: {
                    }
            }) 
        },
        LinkTo(){
            this.$router.push({
                    path: '/main',
                    query: {
                    }
            }) 
        },
        GetMxDet(modenum){


            var Modeldetail=this.GLOBAL.Modeldetail;
                this.$http.post(Modeldetail,{num:modenum},{'headers': {'Content-Type': 'application/json','token':this.myHeaders.token}},{emulateJSON:true}).then(function(res){
                    //   console.log(res);
                    if(res.body.code===0){
                        var data=res.body;
                    //详情页展示内容
                    this.mxtitle=data.data.jbinfo.pzName;
                    this.MxdetContent[0].content=data.data.jbinfo.zwName;
                    this.MxdetContent[1].content=data.data.jbinfo.pzName;
                    this.MxdetContent[2].content=data.data.jbinfo.modeName;
                    this.MxdetContent[3].content=data.data.jbinfo.szQuyu;
                    this.MxdetContent[4].content=data.data.jbinfo.pzLaiyuan;
                    this.MxdetContent[5].content=data.data.jbinfo.syZq;
                    this.MxdetContent[6].content=data.data.jbinfo.kxJd;
                    this.zpydlists=data.data.jslist;   
                }
                      
                                         
                },function(err){})

        },
      },
      mounted() {
        this.requetImgUrl=this.GLOBAL.ImgURL;
        this.username=storage.get('username');
        this.myHeaders.token=storage.get('token');
        this.GetMxDet(this.$route.query.modenum)
        },
    }
  </script>
  
  <style  scoped>
    .topheader{
        width: 100%;
        height: 40px;
        background: #3a8ee6;
        display: flex;
    }
    .topheaderleft{
        width: 50%;
        height: 40px;
        padding-left: 20px;
        line-height: 40px;
        box-sizing: border-box;
        text-align: left;
        color: #ffffff;
        font-size: 16px;
    }
    .topheaderright{
        width: 50%;
        height: 40px;
        padding-right: 20px;
        line-height: 40px;
        box-sizing: border-box;
        color: #ffffff;
        font-size: 16px;
        display: flex;
        justify-content: flex-end;
    }
    .back{
        cursor: pointer;
        font-size: 14px;
    }
    .outlogin{
        margin-left: 20px;
        font-size: 14px;
        cursor: pointer;
    }
    .content{
        width: 80%;
        margin: 0 auto;
    }
    .steps{
        width: 100%;
        margin-top: 20px;
    }
    .steps ul{
        width: 100%;
        height: 70px;
        display: flex;
    }
    .steps ul li{
        width: 33.33%;
        height: 70px;
        display: flex;
        flex-wrap: wrap;
    }
    .steptop{
        width: 100%;
        height: 40px;
        display: flex;
    }
    .line{
        width: calc(50% - 20px);
        height: 10px;
        background: #eeeeee;
        margin-top: 15px;
    }
    .stepbottom{
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
       
    }

    .stepsicon{
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #eeeeee;
        display: block;
        border-radius: 30px;
        font-size: 16px;
        font-weight: bold;
        
    }

    .active .steptop .line{
        background: #4EB944;
    } 
    .active .steptop .stepsicon{
        background:#4EB944;
        color: #ffffff;
    }
    .active .stepbottom{
        color: #4EB944;
    }
/*商品列表*/
.kh-list{
width: 80%;
margin: 40px auto;
}

.kh-list-title{
width: 80%;
display: flex;
justify-content: space-between;
margin-bottom: 10px;
}
.kh-list-title-tips{
height: 36px;
line-height: 36px;
font-weight: 500;
font-size: 30px;
color: #409EFF;

}
.kh-btns{
width: 300px;
text-align: right;
}
.el-table /deep/ th{
background:#eeeeee ;
border-color: #dddddd ;
color: #000000;
text-align: center;
}
.el-dropdown-link {
cursor: pointer;
color: #409EFF;
}
.el-icon-arrow-down {
font-size: 12px;
}
.avatar-uploader /deep/ .el-upload {
border: 1px dashed #d9d9d9;
border-radius: 6px;
cursor: pointer;
position: relative;
overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
border-color: #409EFF;
}
.avatar-uploader-icon {
font-size: 28px;
color: #8c939d;
width: 120px;
height: 120px;
line-height: 120px;
text-align: center;
}
.avatar {
width: 120px;
height: 120px;
display: block;
}
.el-button--medium{
  width: 100px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 220px;
}
.addjyjs{
width: 86%;
height: 130px;
margin: 0 auto;
}

.sp-btns-list{
  width: 100%;
    height: 40px;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 20px;
    background-color: #f5f7fa;
    border: 1px solid #e4e7ed;
    -webkit-transition: inline-block .3s, left .3s, width .3s, margin-left .3s, font-size .3s; 
    transition: inline-block .3s, left .3s, width .3s, margin-left .3s, font-size .3s;
}
.el-link{
padding: 0 20px;
    height: 38px;
    display: inline-block;
    cursor: pointer;
}
 .el-link:hover{
  text-decoration: none;
}
.el-link /deep/.el-link--inner{
  color: #909399;
  height: 38px;
  display: inline-block;
}
.el-link.spbtn-active /deep/  .el-link--inner{
  color: #17B3A3 !important;
  border-bottom: 3px #17B3A3 solid;
}
.el-date-editor /deep/.el-range-separator{
    width: 10%;
} 
.el-button+.el-button{
  margin-left: 0px;
}
.el-link{
    line-height: 38px;
}   
.el-link /deep/ .el-link--inner{
    color: #1560f5 !important;
}
.mxdet-content{
    width: 100%;
}
.mxdet-lists{
    list-style-type: none;
    padding: 0px;
}
.mxdet-lists li{
    width: 100%;
    border-bottom: 1px dotted #b6b6b6;
    display: flex;
    background: #f9f9f9;
}
.list-title{
width: 100px;
height: 60px;
background: #eaeaea;
text-align: center;
line-height: 60px;
}
.list-content{
    width:88%;
    padding-left: 20px;
}
.zpyd-content{
    width: 100%;  
}
.zpyd-title{
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    color: #636363;
    border-bottom: 1px dashed #dddddd;
    font-weight: 600;
}
.zpydlists{
    list-style-type: none;
    padding: 0px;
}
.zpydlists-title{
    width: 100%;
    height: 80px;
    margin-top: 20px;
    display: flex;
}
.title-icons{
    width: 6px;
    height: 24px;
    margin-top: 28px;
    background: #17B3A3;
}
.icons{
    border: 0;
    vertical-align: bottom;
    width: 80px;
    margin-left: 10px;
    padding-bottom: 15px;
}
.zpyd-times{
    width: 260px;
    height: 80px;
    line-height: 80px;
    font-size: 24px;
    margin-left: 10px;
}
.zq-time{
    height: 80px;
    line-height: 80px;
    font-size: 16px;
    color: #ababab;
}
.nextbtns{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    margin: 40px 0;
}
.nextbtn{
    width: 120px;
}
  </style>
  


// WEBPACK FOOTER //
// src/components/MAKEMODEL/makemodelstepthree.vue